import './App.css';
import AnimateBg from './components/AnimateBg';
import Header from './components/Header';
import AboutBg from './components/AboutBg';
import About from './sections/About'
import Skills from './sections/Skills';
import Education from './sections/Education';
import Experience from './sections/Experience';
import Project from './sections/Project';
import { useEffect, useState } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

library.add(fab, fas);

const menuItems = [
  { label: 'About', elem: 'about', link: '#about' },
  { label: 'Skills', elem: 'skills', link: '#skills' },
  { label: 'Education', elem: 'education', link: '#education' },
  { label: 'Experience', elem: 'experience', link: '#experience' },
  { label: 'Projects', elem: 'projects', link: '#projects' },
];

function App() {
  const [showMobileMenu, setShowMobileMenu] = useState(false);

  useEffect(() => {
    if (showMobileMenu) {
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.overflowY = "unset";
      document.body.style.overflowX = "hidden";
    }
  }, [showMobileMenu]);

  const toggleMboileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  return (
    <div className="App">
      <AboutBg/>
      <Header menuItems={menuItems} showMobileMenu={showMobileMenu} toggleMboileMenu={toggleMboileMenu} />
      <div className="text-white">
        <AnimateBg/>
        <About/>
        <Skills/>
        <Education/>
        <Experience/>
        <Project/>
      </div>
    </div>
  );
}

export default App;
